import {ChangeDetectionStrategy, Component, DestroyRef, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {EMPTY} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {GetPetOwner, PetsClient, SwaggerException} from 'shared';

@Component({
  selector: 'app-pet-redirect',
  template: '<p>{{ message() }}</p>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PetRedirectComponent implements OnInit {
  readonly message = signal('Opening pet…');

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly petsClient: PetsClient,
              private readonly destroyRef: DestroyRef) {
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      switchMap(params => {
        const petId = params.get('id');
        this.message.set('Opening pet…');
        return this.petsClient.getPetOwner(new GetPetOwner({pet_id: petId})).pipe(
          map(ownerId => ['/customers', ownerId, 'pets', petId]),
          catchError((error: SwaggerException) => {
            this.message.set(error.status === 404 ? 'Pet not found' : 'Unable to open pet');
            return EMPTY;
          })
        );
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(commands => void this.router.navigate(commands, {replaceUrl: true}));
  }
}
